import types from "./types";

const fetchMagnetWorkSettingsStart = () => {
  return {
    type: types.FETCH_MAGNET_WORK_SETTINGS_START,
  };
};

const fetchMagnetWorkSettings = magnetWorkSettings => {
  return {
    type: types.FETCH_MAGNET_WORK_SETTINGS,
    payload: magnetWorkSettings,
  };
};

const fetchMagnetWorkSettingsError = err => {
  return {
    type: types.FETCH_MAGNET_WORK_SETTINGS_ERROR,
    payload: err,
  };
};

const progress = progress => {
  return {
    type: types.PROGRESS,
    payload: progress,
  };
};

const selectBenchmarks = (unit, benchmarks) => {
  return {
    type: types.SELECT_BENCHMARKS,
    payload: {
      unit,
      benchmarks,
    },
  };
};

const applyBenchmark = (unit, benchmark) => {
  return {
    type: types.APPLY_BENCHMARK,
    payload: {
      unit,
      benchmark,
    },
  };
};

export default {
  fetchMagnetWorkSettings,
  fetchMagnetWorkSettingsStart,
  fetchMagnetWorkSettingsError,
  progress,
  selectBenchmarks,
  applyBenchmark,
};



// WEBPACK FOOTER //
// ./src/redux/magnetWorkSettings/actions.js